import React, { FunctionComponent } from "react";
import { FocusableHeader } from "../../components";
import { Plan } from "../../@types";
import PlanInfo from "./PlanInfo";
import { useTranslate } from "../../helpers";

const FormErrorPage: FunctionComponent<{ plan: Plan }> = ({ plan }) => {
  const t = useTranslate();

  return (
    <div className="ds-u-measure--wide">
      <FocusableHeader
        className="EnrollmentFormPage__header ds-u-margin-top--7"
        text={t("enroll_form.error.unable_to_process")}
      />
      <PlanInfo plan={plan} onlyName showRequiredFieldNote={false} />
      <p>{t("enroll_form.error.apology")}</p>
    </div>
  );
};

export default FormErrorPage;
